import styled from 'styled-components';
import {caretDown} from '../../../../../assets/symbols/symbols/Symbols.css';
import {dFlexCenter} from '../../../../../globalVariables/GlobalFlex';
import {getColor} from '../../../utils/themeUtils';

export const nameCaret = styled.div`
    flex-shrink: 0;
    width: var(--dimension-8);
    height: var(--dimension-8);
    ${dFlexCenter}
    border-radius: var(--radius-full);
    cursor: pointer;
    background: var(--color-bg-surface-default, rgba(0, 0, 0, 0.05));
    &::before {
        content: '';
        width: var(--dimension-3);
        height: var(--dimension-3);
        background-color: ${p => getColor(p.theme.isDarkMode)};
        -webkit-mask: url("${caretDown}") center / contain no-repeat;
        mask: url("${caretDown}") center / contain no-repeat;
    }
`;
